import React, { useEffect, useState } from "react";
import { get_proveedores } from "../../../../actions/proveedor";
import { SelectUi } from "../../../ui/SelectUi";

export const ProveedoresSelect = ({ ...restProps }) => {
  const [proveedores, setProveedores] = useState([]);
  const OnLoadData = async () => {
    const data = await get_proveedores();
    setProveedores(data);
  };
  useEffect(() => {
    OnLoadData();
  }, []);

  return <SelectUi data={proveedores} {...restProps} />;
};
